import React from 'react'
import { Link, LinkProps } from 'react-router-dom'
import { useCheckPermission } from 'cityads-v3/hooks/permissions'

function LinkToPayments(
  {
    children,
    ...props
  }: LinkProps,
  ref: React.ForwardedRef<HTMLAnchorElement>
): JSX.Element {
  const checkPermission = useCheckPermission()

  return checkPermission('show_v3_payments')
    ? <Link ref={ref} {...props} to="/publisher/payments">{children}</Link>
    : <a ref={ref} {...props} href="/webmaster/office/payments">{children}</a>
}

export default React.forwardRef(LinkToPayments) as React.ElementType
